import {
  IWebsiteBuilderElementBase,
  IWebsiteBuilderElementDataBase,
  IWebsiteBuilderElementStretch,
  IWebsiteBuilderElementDesignStyles,
  TWebsiteBuilderElement,
} from "./websiteBuilderElement";

export const enum WebsiteBuilderDividerWeight {
  THIN = 1,
  REGULAR = 2,
  THICK = 5,
  EXTRA_THICK = 10,
}

export type TWebsiteBuilderDividerStyle = "solid" | "dashed" | "dotted";

export interface IWebsiteBuilderDividerSettings {
  weight: WebsiteBuilderDividerWeight;
  style: TWebsiteBuilderDividerStyle;
}

export interface IWebsiteBuilderDividerData extends IWebsiteBuilderElementDataBase {
  type: "divider";
  settings: IWebsiteBuilderDividerSettings;
  stretch: IWebsiteBuilderElementStretch;
}

export interface IWebsiteBuilderDivider extends IWebsiteBuilderElementBase {
  element: IWebsiteBuilderDividerData;
}

export function isWebsiteBuilderDivider(node: TWebsiteBuilderElement): node is IWebsiteBuilderDivider {
  return node?.element?.type === "divider";
}

export function generateDefaultDivider(): IWebsiteBuilderDivider {
  return {
    id: crypto.randomUUID(),
    type: "element",
    element: {
      type: "divider",
      position: { x: 0, y: 0 },
      dimensions: { width: 600, height: WebsiteBuilderDividerWeight.EXTRA_THICK },
      zIndex: null,
      settings: {
        weight: WebsiteBuilderDividerWeight.REGULAR,
        style: "solid",
      },
      stretch: {
        enabled: false,
        margin: 0,
      },
    },
  };
}

export function generateDividerDesignStyles(
  settings: IWebsiteBuilderDividerSettings,
): IWebsiteBuilderElementDesignStyles {
  return {
    className: "website-builder-divider",
    style: {
      borderTopWidth: settings.weight,
      borderTopStyle: settings.style,
    },
  };
}
